(() => {
  'use strict';
  const selector = '.bsc-simple-product';

  function initThumbNav(root) {
    const wrap = root.querySelector('[data-simple-thumbs-wrap]');
    const track = root.querySelector('[data-simple-thumbs]');
    const prevBtn = root.querySelector('[data-simple-thumb-nav="prev"]');
    const nextBtn = root.querySelector('[data-simple-thumb-nav="next"]');
    if (!wrap || !track || !prevBtn || !nextBtn) return;

    const EPSILON = 2;

    const update = () => {
      const overflowing = track.scrollWidth - track.clientWidth > EPSILON;
      wrap.classList.toggle('has-thumb-nav', overflowing);

      if (!overflowing) {
        prevBtn.hidden = true;
        nextBtn.hidden = true;
        wrap.classList.remove('can-scroll-prev', 'can-scroll-next');
        return;
      }

      const atStart = track.scrollLeft <= EPSILON;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - EPSILON;

      prevBtn.hidden = atStart;
      nextBtn.hidden = atEnd;
      wrap.classList.toggle('can-scroll-prev', !atStart);
      wrap.classList.toggle('can-scroll-next', !atEnd);
    };

    const scrollByPage = (direction) => {
      const amount = Math.max(track.clientWidth * 0.8, 160) * direction;
      track.scrollBy({ left: amount, behavior: 'smooth' });
    };

    prevBtn.addEventListener('click', () => scrollByPage(-1));
    nextBtn.addEventListener('click', () => scrollByPage(1));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    requestAnimationFrame(update);
    window.addEventListener('load', update, { once: true });
  }

  function initialise(root) {
    if (!root || root.dataset.simpleProductReady === 'fast') return;
    root.dataset.simpleProductReady = 'fast';
    const placeholder = root.querySelector('[data-simple-placeholder]');
    // Every media item (image or video) is pre-rendered into its own slide and toggled
    // via the `hidden` attribute, rather than swapping a single <img>'s src at runtime.
    // This lets video/external-video media render and play natively, which a single
    // shared <img> element could never do.
    const slides = Array.from(root.querySelectorAll('[data-simple-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-simple-thumb]'));
    const variant = root.querySelector('[data-simple-variant]');
    const price = root.querySelector('[data-simple-price]');
    const sku = root.querySelector('[data-simple-sku]');
    const enquiry = root.querySelector('[data-simple-product-enquiry]');

    initThumbNav(root);

    const setActive = (thumb) => thumbs.forEach((item) => {
      const active = item === thumb;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    const pauseSlide = (slide) => {
      const video = slide.querySelector('video');
      if (video && !video.paused) video.pause();
    };

    function show(thumb) {
      if (!thumb) return false;
      const mediaId = thumb.dataset.mediaId;
      const target = slides.find((slide) => slide.dataset.mediaId === mediaId);
      if (!target) return false;
      setActive(thumb);
      slides.forEach((slide) => {
        const isTarget = slide === target;
        if (!isTarget) pauseSlide(slide);
        slide.hidden = !isTarget;
      });
      placeholder?.classList.add('is-hidden');
      return true;
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => show(thumb));
    });

    variant?.addEventListener('change', () => {
      const option = variant.options[variant.selectedIndex];
      if (!option) return;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (sku) { sku.textContent = option.dataset.sku || ''; sku.hidden = !option.dataset.sku; }
      const related = thumbs.find((thumb) => thumb.dataset.mediaId === option.dataset.mediaId);
      if (related) show(related);
    });

    function openEnquiry() {
      const form = document.getElementById('GlobalContactForm');
      const option = variant ? variant.options[variant.selectedIndex] : null;
      const variantTitle = option ? option.textContent.replace(/\s+\u2014\s+Unavailable$/, '').trim() : '';
      const title = root.dataset.productTitle || document.title;
      const url = root.dataset.productUrl || location.href;
      if (form) {
        const set = (name, value) => { const field = form.querySelector(`[name="${name}"]`); if (field) field.value = value; };
        set('contact[Product]', title); set('contact[Product URL]', url); set('contact[Variant]', variantTitle);
        const quantity = form.querySelector('[name="contact[Required Quantity]"]');
        if (quantity) { quantity.placeholder = 'Required quantity'; quantity.value = ''; }
        const message = form.querySelector('textarea[name="contact[body]"],textarea');
        if (message && !message.value.trim()) message.value = `Please share a tailored quote for ${title}${variantTitle ? ` (${variantTitle})` : ''}.`;
      }
      if (typeof window.openContactForm === 'function') window.openContactForm(); else document.getElementById('callback-btn')?.click();
      setTimeout(() => form?.querySelector('[name="contact[Required Quantity]"]')?.focus({ preventScroll: true }), 180);
    }
    enquiry?.addEventListener('click', openEnquiry);
  }

  const all = (scope = document) => scope.querySelectorAll(selector).forEach(initialise);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => all(), { once: true }) : all();
  document.addEventListener('shopify:section:load', (event) => all(event.target));
})();
